import { AppState } from '../../..';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { CommentSearchComponent, CommentSearchComponentProperties } from './comments-search.component';
import { CommentState } from '../../comments.reducer';
import { CommentType, CommentViewModel } from '@models/Comment';
import { getComments, deleteComment } from '../../comments.actions';
import { getProfile } from '../../../profile/profile.actions';
import { ModalProps } from '@common/components/modal/_components/modal.component';
import { toggleModal, toggleDialog } from '@common/components/common.actions';
import { actions } from 'react-redux-form';
import { completeComment } from '../../../actioning/actioning.actions';
import FormNames from '@constants/FormNames.enum';

// This is used to translate the state of the page to the props on the component
function mapStateToProps(
  state: AppState,
  ownProps: { entityId: number; commentType: CommentType }
): Partial<CommentSearchComponentProperties> {
  return {
    message: state.comment.message,
    query: state.comment.query,
    commentsLoading: state.comment.commentsLoading,
    commentsPageCount: state.comment.commentsPageCount,
    commentsPageNumber: state.comment.commentsPageNumber,
    commentsPageSize: state.comment.commentsPageSize,
    commentsOrderBy: state.comment.commentsOrderBy,
    comments: state.comment.comments,
    commentType: ownProps.commentType,
    entityId: ownProps.entityId,
    currentProfile: state.profile.currentProfile
  };
}

// This should create proxy wrappers for actions used by the component
function mapDispatchToProps(
  dispatch: Dispatch<CommentState>,
  ownProps: { entityId: number; commentType: CommentType }
): Partial<CommentSearchComponentProperties> {
  return {
    getComments: (entityId, commentsType, query, pageSize, pageNumber, orderBy, orderDirection) =>
      dispatch(getComments(entityId, commentsType, query, pageSize, pageNumber, orderBy, orderDirection)),
    toggleModal: (modalProps: ModalProps) => {
      dispatch(toggleModal(modalProps));
    },
    toggleDialog: (comment: string) => {
      dispatch(toggleDialog({ textYes: 'Close', text: comment, onYesClick: () => toggleDialog() }));
    },
    completeComment(oldComment: CommentViewModel, commentType: CommentType) {
      dispatch(completeComment(oldComment.commentId, CommentType[commentType])).then(() => {
        dispatch(actions.reset(FormNames.CommentForm));
        dispatch(toggleModal());
        dispatch(getComments(ownProps.entityId, commentType, '', 10, 1, 'addedDate', 'desc'));
      });
    },
    deleteComment: (comment: CommentViewModel, commentsType) => {
      dispatch(deleteComment(comment.commentId, commentsType));
    },
    clearComments: () => {
      dispatch(actions.reset(FormNames.CommentForm));
    },
    getProfile: () => dispatch(getProfile())
  };
}

// Connect function "wires" both of the map functions and returns a wrapper container for the component
export const CommentSearch = connect(
  mapStateToProps,
  mapDispatchToProps
)(CommentSearchComponent);



// WEBPACK FOOTER //
// ./src/comments/_components/comments-search/comments-search.container.ts